/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import React, { ReactNode } from 'react';

// Mantine
import {
	Select as NativeSelect,
	Image,
	Box,
} from '@mantine/core';

// Style
import classes from './LanguageSelect.module.css';
import languages from './languages.config';

// Icons
import ArrowDownIcon from '@assets/icons/arrow-down.svg';
import LanguagesIcon from '@assets/icons/languages.svg';
import clsx from 'clsx';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const LanguageSelect = (props: {
	onChange?: (data: any) => void;
	children?: ReactNode;
	size?: string;
	variant?: string;
	color?: string;
	fullWidth?: boolean;
	loading?: boolean;
	disabled?: boolean;
	readOnly?: boolean;
	leftSection?: React.ReactNode;
	defaultValue?: string;
}) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<Box
			className={clsx(
				classes.container,
				props.disabled && classes.disabled
			)}
		>
			<Image
				className={classes.icon}
				src={LanguagesIcon}
			/>
			<NativeSelect
				allowDeselect={false}
				classNames={classes}
				withCheckIcon={false}
				checkIconPosition="left"
				data={languages}
				rightSectionPointerEvents="none"
				rightSection={<Image src={ArrowDownIcon} />}
				{...props}
			/>
		</Box>
	);
};
